<app-loader *ngIf="loaderIcon | async"></app-loader>
<div class="layout-container">
    <app-operations [isCollapsed]="isCollapsed"></app-operations>
    <div class="main-content">
        <app-top-bar (toggleSidebar)="handleToggle()"></app-top-bar>
        <div class="content-area" [userPermissionHandler]="viewPermissionHandlerData">
            <div class="d-flex justify-content-between align-items-center mb-3">
                <h5 class="fw-semibold">{{'Vendor' | wordReplace}} Payouts</h5>
            </div>
            <hr />
            <div class="row" [formGroup]="vendorsPayoutForm">
                <div class="col-md-6 col-lg-3 form-inline-group">
                    <label for="fromDate" class="form-label mb-0">From Date</label>
                    <ejs-datepicker class="form-control p-0" formControlName="fromDate" [format]="'MM/dd/yyyy'"
                        [readonly]=" !isCalculateEnabled || !isFromDateEditable()" (change)="onStartDateChange($event)"
                        [max]="maxExpiryDate"></ejs-datepicker>
                </div>
                <div class="col-md-6 col-lg-3 form-inline-group">
                    <label for="toDate" class="form-label mb-0">To Date</label>
                    <ejs-datepicker class="form-control p-0" formControlName="toDate" [format]="'MM/dd/yyyy'"
                        [readonly]="!isCalculateEnabled" [min]="minExpiryDate" [max]="maxExpiryDate"></ejs-datepicker>
                </div>
                <div class="col-md-6 col-lg-3 form-inline-group">
                    <label for="userName" class="form-label mb-0">User Name</label>
                    <input type="text" class="form-control" id="userName" [value]="userName" readonly>
                </div>
                <div class="col-md-6 col-lg-3 form-inline-group">
                    <label for="pcTerminal" class="form-label mb-0">Terminal</label>
                    <select class="form-select" id="pcTerminal" formControlName="Terminal">
                        <option [ngValue]="null" disabled>Select</option>
                        @for (terminal of posTerminals; track terminal.Id) {
                        @if (!terminal.InActive) {
                        <option [ngValue]="terminal.Name">{{ terminal.Name }}</option>
                        }
                        }
                    </select>
                </div>
            </div>
            <div class="row">
                <div class="col-12 text-start mt-2">
                    <div *ngIf="isOtherButtonsEnabled" class="row g-2 align-items-center filters mt-2 mb-3">
                        <div class="col-md-3 mt-0">
                            <ejs-dropdownlist id='dropdownFilter' [dataSource]='SearchFields'
                                [fields]='DropDownSearchFields' [(ngModel)]="advSearchLovId" i18n-placeholder
                                placeholder='Select Field'></ejs-dropdownlist>
                        </div>
                        <div class="col-md-3 mt-0">
                            <input type="text" class="form-control form-control-sm" [(ngModel)]="advSearchKeyword"
                                placeholder="Search Value" />
                        </div>
                        <div class="col-md-2 mt-0 d-flex gap-2">
                            <button class="btn btnAS btn-sm" (click)="searchWithAdv()">Apply</button>
                            <button class="btn btn-outline-AS" (click)="clearAdvSearch()">Clear</button>
                        </div>
                    </div>

                    <!-- Sort By -->
                    <div class="d-flex align-items-center mb-3" *ngIf="displayVendorIdFilterInPayout">
                        <label class="sort-by-label mb-0 me-3">
                            Sort By:
                        </label>

                        <div class="d-flex align-items-center gap-3">

                            <div class="form-check d-flex align-items-center mb-0">
                                <input class="form-check-input mt-0 me-2" type="radio" name="sortBy" id="sortById"
                                    [value]="0" [(ngModel)]="sortBy" (change)="sortVendors()">

                                <label class="form-check-label mb-0" for="sortById">
                                    {{ 'Vendor ID' | wordReplace }}
                                </label>
                            </div>
                            <div class="form-check d-flex align-items-center mb-0">
                                <input class="form-check-input mt-0 me-2" type="radio" name="sortBy" id="sortByName"
                                    [value]="1" [(ngModel)]="sortBy" (change)="sortVendors()">
                                <label class="form-check-label mb-0" for="sortByName">
                                    {{ 'Vendor Name' | wordReplace }}
                                </label>
                            </div>
                        </div>
                    </div>

                    <ejs-grid #grid [dataSource]="filteredVendorsPayoutList" [height]="350">
                        <e-columns>
                            <e-column field="VendorAlphaID" [headerText]="'Vendor ID' | wordReplace" width="120"
                                textAlign="Left"></e-column>

                            <e-column field="vendorName" [headerText]="'Vendor Name' | wordReplace" width="160"
                                textAlign="Left"></e-column>

                            <e-column field="boothNumber" [headerText]="'Booth #' | wordReplace" width="140"
                                textAlign="Left"></e-column>

                            <e-column field="rentalBoothSales" headerText="Rental Booth Sales" width="170"
                                textAlign="Right" type="number" format="$#,##0.00;($#,##0.00)"></e-column>

                            <e-column field="consignmentSales" headerText="Consignment Sales" width="180"
                                textAlign="Right" type="number" format="$#,##0.00;($#,##0.00)"></e-column>

                            <e-column field="onlineSales" *ngIf="includeOnlineSales" headerText="Online Sales"
                                width="180" textAlign="Right" type="number" format="$#,##0.00;($#,##0.00)"></e-column>

                            <e-column field="SalesTax" headerText="Sales Tax" width="150" textAlign="Right"
                                type="number" format="$#,##0.00;($#,##0.00)"></e-column>

                            <e-column field="totalSales" headerText="Total Sales" width="150" textAlign="Right"
                                type="number" format="$#,##0.00;($#,##0.00)"></e-column>

                            <e-column field="flatCommission" headerText="Flat Comm. Vendor-wise" width="200"
                                textAlign="Right" type="number" format="$#,##0.00;($#,##0.00)"></e-column>

                            <e-column field="consignmentCommission" *ngIf="!splitCommissionByPaymentType"
                                headerText="Consignment Commission" width="230" textAlign="Right" type="number"
                                format="$#,##0.00;($#,##0.00)"></e-column>

                            <e-column field="CashCommission" *ngIf="splitCommissionByPaymentType"
                                headerText="Cash Comm. Charges" width="230" textAlign="Right" type="number"
                                format="$#,##0.00;($#,##0.00)"></e-column>

                            <e-column field="CcCheckTcCommission" *ngIf="splitCommissionByPaymentType"
                                headerText="CC/DC/CK Comm. Charges" width="230" textAlign="Right" type="number"
                                format="$#,##0.00;($#,##0.00)"></e-column>

                            <e-column field="creditDebitCharges" headerText="Credit/Debit Card Charges" width="250"
                                textAlign="Right" type="number" format="$#,##0.00;($#,##0.00)"></e-column>

                            <e-column field="vendorAdjustments" [headerText]="'Vendor Adjustments' | wordReplace"
                                width="200" textAlign="Right" type="number" format="$#,##0.00;($#,##0.00)">
                            </e-column>

                            <e-column field="netSales" headerText="Net Sales" width="120" textAlign="Right"
                                type="number" format="$#,##0.00;($#,##0.00)">

                            </e-column>

                            <e-column field="rentalDue" headerText="Rental Due" width="120" textAlign="Right"
                                type="number" format="($#,##0.00);$#,##0.00;$0.00"></e-column>

                            <e-column field="AutoDeductRent" headerText="Auto Deduct Rent" width="190"
                                textAlign="Center">
                                <ng-template #template let-data>
                                    <input type="checkbox" class="form-check-input" [checked]="data.AutoDeductRent"
                                        (change)="onAutoDeductChange($event, data)" />
                                </ng-template>
                            </e-column>

                            <e-column field="PayToVendor" [headerText]="'Pay to Vendor' | wordReplace" width="150"
                                textAlign="Right" type="number" format="$#,##0.00;($#,##0.00)"></e-column>

                            <e-column field="VendorOwes" [headerText]="'Vendor Owes' | wordReplace" width="150"
                                textAlign="Right" type="number" format="($#,##0.00);$#,##0.00;$0.00"></e-column>

                            <!-- <e-column field="AutoPayVendor" [headerText]="'Auto Pay Vendor' | wordReplace" width="180"
                                textAlign="Center">
                                <ng-template #template let-data>
                                    <input type="checkbox" class="form-check-input" [checked]="data.AutoPayVendor"
                                        disabled />
                                </ng-template>
                            </e-column> -->

                            <e-column field="MailPaytChecks" headerText="Mail Pay't Checks" width="170"
                                textAlign="Center">
                                <ng-template #template let-data>
                                    <input type="checkbox" class="form-check-input" [checked]="data.MailPaytChecks"
                                        disabled />
                                </ng-template>
                            </e-column>

                            <e-column field="RefundSalesTax" headerText="Refund Sales Tax" width="180"
                                textAlign="Center">
                                <ng-template #template let-data>
                                    <input type="checkbox" class="form-check-input" [checked]="data.RefundSalesTax"
                                        disabled />
                                </ng-template>
                            </e-column>

                        </e-columns>
                    </ejs-grid>

                </div>
            </div>
            <div class="row">
                <div class="col-12 text-end my-2">
                    <button class="btn btn-success me-1" (click)="calculateVendorsPayout()"
                        [disabled]="!isCalculateEnabled">Calculate</button>
                    <button class="btn btnAS me-1" [disabled]="!isOtherButtonsEnabled"
                        (click)="onReportView('VendorsPayoutReport')">Preview</button>
                    <button class="btn btnAS me-1" [disabled]="!isOtherButtonsEnabled"
                        (click)="onReportView('PostPayoutOutstandingRentalBalanceReport')">Preview Outstanding
                        Rent</button>
                    <ejs-tooltip id='tooltipPayoutSave' target="#btnPayoutSave" position='TopCenter' openMode="Auto"
                        windowCollision="fit" (beforeOpen)="onBeforeOpen($event)"
                        [content]="'You do not have rights to Save Payouts'">
                        <button id="btnPayoutSave" type="button" class="btn btnAS me-1" (click)="saveVendorsPayout()"
                            [userPermissionHandler]="createPermissionHandlerData" [disabled]="!isSaveEnabled">
                            Save
                        </button>
                    </ejs-tooltip>
                    <button class="btn btn-orange me-1" (click)="cancelPayout()" [disabled]="
                        !isOtherButtonsEnabled">Cancel</button>
                </div>
            </div>
        </div>
    </div>
</div>